<div [class]="mixedMode() ? 'h-full' : 'w-full bg-white dark:bg-surface-0 p-6 rounded-xl card-bg'">

  @if (!mixedMode()) {
  <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-8">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Lendee Analytics Dashboard</h1>
    </div>
    <div class="flex flex-wrap items-center gap-3">
      <app-date-picker [value]="datePickerValue" (dateRangeChange)="onDateRangeChange($event)" [showComparison]="false"
        [showGroupBy]="true" class="w-full sm:w-auto">
      </app-date-picker>
      <button type="button" (click)="openCustomizeLayout()"
        class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="7" height="7" x="3" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="14" rx="1" />
          <rect width="7" height="7" x="3" y="14" rx="1" />
        </svg>
        Customize layout
      </button>
    </div>
  </div>
  }

  <ng-template #sectionPin let-sectionId>
    @if (!mixedMode()) {
    <button type="button" (click)="addToCustomDashboard(sectionId); $event.stopPropagation()"
      [disabled]="isAddingToCustomDashboard(sectionId)"
      class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
      [ngClass]="isAddedToCustomDashboard(sectionId)
          ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 !opacity-100 !translate-y-0'
          : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 shadow-md dark:bg-slate-800/95 dark:border-purple-500/40'"
      [title]="isAddedToCustomDashboard(sectionId) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
      @if (isAddingToCustomDashboard(sectionId)) {
      <svg class="animate-spin shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span>{{ isAddedToCustomDashboard(sectionId) ? 'Removing' : 'Adding' }}&hellip;</span>
      } @else if (isAddedToCustomDashboard(sectionId)) {
      <!-- Pinned state: compact green check at rest so the card title
             stays fully visible. Hovering morphs the pill open and flips
             the affordance to a remove minus + label. -->
      <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M20 6 9 17l-5-5" />
      </svg>
      <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M5 12h14" />
      </svg>
      <span
        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
        from Custom Dashboard</span>
      } @else {
      <!-- Not-pinned state: pill hidden at card-rest. On card hover it
             fades in as a compact "+" icon. Hovering the icon then morphs
             the pill open to reveal the label, so the card title is never
             obscured at rest. -->
      <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14" />
        <path d="M12 5v14" />
      </svg>
      <span
        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
        to Custom Dashboard</span>
      }
    </button>
    }
  </ng-template>

  <div [class]="mixedMode() ? 'unified-tile-body h-full' : ''">
    <div class="grid grid-cols-12 gap-6 grid-flow-row-dense" [class.gap-0]="mixedMode()" [class.h-full]="mixedMode()">

      @if (showSection(SectionId.METRICS_OVERVIEW)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.METRICS_OVERVIEW)"
        [style.order]="sectionOrder(SectionId.METRICS_OVERVIEW)">
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.METRICS_OVERVIEW }"></ng-container>
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
            @for (card of metricCards(); track card.title) {
            <div
              class="bg-slate-50/90 dark:bg-surface-2 p-3 rounded-lg border border-gray-100 dark:border-gray-600/60 flex items-start gap-3 relative overflow-hidden">
              @if(isLoading()) {
              <app-individual-toaster fontSize="16px"></app-individual-toaster>
              }
              <div [class]="'p-3 rounded-lg h-12 shrink-0 ' + card.bgClass">
                <app-icon-v2 [name]="card.icon" [size]="24" [class]="card.iconColorClass"></app-icon-v2>
              </div>
              <div class="flex-1 min-w-0">
                <div class="text-xs text-gray-500 dark:text-gray-400 font-medium mb-1">{{ card.title }}</div>
                <div class="text-2xl font-bold text-gray-900 dark:text-white">
                  @if(card.isCurrency) { ${{ card.value | number:'1.2-2' }} } @else { {{ card.value }} }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.KEY_INSIGHTS)) {
      <div [ngClass]="[getSectionColClass(SectionId.KEY_INSIGHTS), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.KEY_INSIGHTS)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.KEY_INSIGHTS }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Key Insights</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">Key takeaways to guide product and growth decisions</p>

        <div class="space-y-4">
          @if (keyInsights.length > 0) {
          @for (insight of keyInsights; track $index) {
          <div class="flex gap-3 items-start">
            <div class="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0"></div>
            <p class="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">{{ insight }}</p>
          </div>
          }
          } @else {
          <div class="flex flex-col items-center justify-center py-10 text-gray-400">
            <app-icon-v2 name="inbox" [size]="40" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No insights available for this period</p>
          </div>
          }
        </div>

        @if (keyInsights.length > 6) {
        <button class="mt-6 text-sm text-blue-600 dark:text-blue-400 font-medium hover:underline cursor-pointer"
          (click)="toggleInsights('insights')">
          View all Insights...
        </button>
        }
      </div>
      }

      @if (showSection(SectionId.RECIPIENT_FUNNEL)) {
      <div [ngClass]="[getSectionColClass(SectionId.RECIPIENT_FUNNEL), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.RECIPIENT_FUNNEL)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.RECIPIENT_FUNNEL }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-1">Recipient Conversion Funnel</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-1">From sign-up to payment plan creation across the
          selected period</p>

        <div class="w-full min-h-[200px] flex items-center justify-center">
          @if (funnelData.length === 0 || (funnelData[0] && funnelData[0].value === 0)) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="inbox" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No funnel data available</p>
          </div>
          } @else {
          <app-funnel-chart [data]="funnelData" [height]="'200px'" [width]="'80%'" [showBorder]="false"
            [showShadow]="false" [showLegends]="true" [showLegendColor]="true" [padding]="'0 0'"
            [margins]="{top: 20, right: 0, bottom: 0, left: 0}" [showLeftLabel]="false" [showRightLabel]="false"
            [darkThemeClass]="'dark:bg-surface-2'" [config]="{ title: '', barStyle: 'gradient' }" class="w-full">
          </app-funnel-chart>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.REQUEST_OFFER_PERFORMANCE)) {
      <div [ngClass]="[getSectionColClass(SectionId.REQUEST_OFFER_PERFORMANCE), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.REQUEST_OFFER_PERFORMANCE)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.REQUEST_OFFER_PERFORMANCE }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Request and Offer Performance</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Tracking the gap between requests raised and offers
          generated</p>

        <div class="w-full min-h-[250px] flex items-center justify-center">
          @if (!hasPerformanceData) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="chartLine" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No performance data available</p>
          </div>
          } @else {
          <app-line-area-chart [series]="requestOfferPerformanceData" [height]="250" [dateUnit]="datePickerValue.unit"
            [margins]="{ top: 20, right: 20, bottom: 20, left: 40 }" [cardPadding]="'1.5rem 0.5rem 0rem 0.5rem'"
            [showPoints]="true" [areaOpacity]="0" [useDualYAxis]="false" [darkThemeClass]="'dark:bg-surface-2'"
            [yAxis]="{show: true, showGrid: true, showAxisLine: true, gridStyle: 'dashed'}"
            [xAxis]="{show: true, showGrid: false, showAxisLine: true, showOnlyFirstLast: true}"
            [legend]="{ show: true, position: 'bottom' }" class="w-full">
          </app-line-area-chart>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.SIGNUPS_TREND)) {
      <div [ngClass]="[getSectionColClass(SectionId.SIGNUPS_TREND), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.SIGNUPS_TREND)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.SIGNUPS_TREND }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Recipient Signups Supporter Signups</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Recipient and supporter signups over time</p>

        <div class="w-full min-h-[250px] flex items-center justify-center">
          @if (!hasSignupsData) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="users" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No signup data available</p>
          </div>
          } @else {
          <app-line-area-chart [series]="signupsData" [height]="250" [dateUnit]="datePickerValue.unit"
            [margins]="{ top: 0, right: 20, bottom: 20, left: 40 }" [cardPadding]="'1.5rem 0.5rem 0rem 0.5rem'"
            [showPoints]="false" [useDualYAxis]="false" [darkThemeClass]="'dark:bg-surface-2'"
            [yAxis]="{show: true, showGrid: true, showAxisLine: true, gridStyle: 'dashed'}"
            [xAxis]="{show: true, showAxisLine: true, showGrid: false, showOnlyFirstLast: true}"
            [legend]="{ show: true, position: 'bottom' }" class="w-full">
          </app-line-area-chart>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.REQUEST_STATUS)) {
      <div [ngClass]="[getSectionColClass(SectionId.REQUEST_STATUS), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.REQUEST_STATUS)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.REQUEST_STATUS }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Request Status Summary</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Current distribution of request lifecycle states</p>

        <div class="w-full flex items-center justify-center min-h-[250px]">
          @if (!hasRequestStatusData) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="chartPie" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No status data available</p>
          </div>
          } @else {
          <!-- Chart Area with Custom Legend -->
          <div class="flex items-center gap-8 lg:gap-16 px-4">
            <div class="shrink-0">
              <app-donut-chart [data]="requestStatusData" [width]="200" [height]="200" [showLegend]="false"
                [variant]="'concentric'" [radiusScale]="0.8" [outerRadiusRatio]="1.25" [innerRadiusRatio]="0.35"
                [gapRatio]="0.5" class="w-full">
              </app-donut-chart>
            </div>

            <!-- Custom Grid Legend -->
            <div class="grid grid-cols-2 gap-x-8 gap-y-6 flex-1">
              @for (item of requestStatusData; track item.label) {
              <div class="flex items-center gap-3">
                <div class="w-1 h-8 rounded-full" [style.background-color]="item.color"></div>
                <div class="flex flex-col">
                  <span class="text-xs text-gray-500 dark:text-gray-400 font-medium">{{ item.label }}: <span
                      class="text-sm text-gray-900 dark:text-white font-bold ml-1">{{ item.value | number
                      }}</span></span>
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.OFFER_OUTCOME)) {
      <div [ngClass]="[getSectionColClass(SectionId.OFFER_OUTCOME), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.OFFER_OUTCOME)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.OFFER_OUTCOME }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Offer Outcome Analysis</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Distribution of offer responses and acceptance rate</p>

        <div class="w-full min-h-[130px] flex items-center justify-center">
          @if (!hasOfferOutcomeData) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="chartBar" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No outcome data available</p>
          </div>
          } @else {
          <app-single-bar class="w-full block" [data1]="offerOutcomeData" [valueKey]="'count'" [showBarValue]="true"
            [barWidthScale]="0.6" [chartHeight]="130" [minHeight]="130" [marginBottom]="20" [marginTop]="0"
            [barStyle]="'solid'" [direction]="'bottom-to-top'">
          </app-single-bar>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.OVERDUE_COLLECTIONS)) {
      <div [ngClass]="[getSectionColClass(SectionId.OVERDUE_COLLECTIONS), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.OVERDUE_COLLECTIONS)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.OVERDUE_COLLECTIONS }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Overdue & Collections Progress</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Movement of overdue plans into collections and recovery</p>

        <div class="w-full min-h-[250px] flex items-center justify-center">
          @if (!hasOverdueData) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="inbox" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No progress data available</p>
          </div>
          } @else {
          <app-horizontal-bar-chart [data]="overdueProgressData" [showYAxisGrid]="false" [showXAxisGrid]="true"
            [showXAxisLabel]="true" [showBarsValue]="false" [barHeight]="25" [barThickness]="15" [minHeight]="250"
            [barPadding]="15" [marginTop]="20" [marginBottom]="20" [leftMargin]="140" [showLegend]="false"
            class="w-full">
          </app-horizontal-bar-chart>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.PARTIAL_REPAYMENTS)) {
      <div [ngClass]="[getSectionColClass(SectionId.PARTIAL_REPAYMENTS), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.PARTIAL_REPAYMENTS)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PARTIAL_REPAYMENTS }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Partial Repayments on Overdue Loans</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">Partial repayments on overdue loans before recovery
          actions begin</p>

        <div class="w-full min-h-[250px] flex items-center justify-center">
          @if (!hasPartialRepaymentsData) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="chartLine" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No repayment data available</p>
          </div>
          } @else {
          <app-line-area-chart [series]="partialRepaymentsData" [margins]="{ top: 20, right: 20, bottom: 40, left: 40 }"
            [showPoints]="true" [showValueLabels]="true" [curveType]="'monotoneX'" [dateUnit]="datePickerValue.unit"
            [height]="250" [useDualYAxis]="false" [markerLines]="repaymentsMarkerLines"
            [darkThemeClass]="'dark:bg-surface-2'"
            [yAxis]="{show: true, showLabels: false, showGrid: true, showAxisLine: false, gridStyle: 'dashed'}"
            [xAxis]="{show: true, showAxisLine: true, showGrid: false, showLabels: true, showOnlyFirstLast: true}"
            [legend]="{ show: false }" class="w-full">
          </app-line-area-chart>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.RECEIVABLES_VS_REVENUE)) {
      <div [ngClass]="[getSectionColClass(SectionId.RECEIVABLES_VS_REVENUE), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.RECEIVABLES_VS_REVENUE)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.RECEIVABLES_VS_REVENUE }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Receivables Completion vs Revenue</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Completed receivables translate into actual revenue</p>

        <div class="w-full min-h-[300px] flex items-center justify-center">
          @if (!hasReceivablesVsRevenueData) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="chartBar" [size]="48" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No receivables data available</p>
          </div>
          } @else {
          <div class="w-full"
            [class.overflow-x-auto]="datePickerValue.unit === 'week' && datePickerValue.presetLabel === 'Last 90 Days'">
            <div class="w-full"
              [class.min-w-[1000px]]="datePickerValue.unit === 'week' && datePickerValue.presetLabel === 'Last 90 Days'">
              <app-multiple-bar [data1]="$safeNavigationMigration(receivablesChartData()?.data1)" [data2]="$safeNavigationMigration(receivablesChartData()?.data2)"
                [data3]="$safeNavigationMigration(receivablesChartData()?.data3)" [data4]="$safeNavigationMigration(receivablesChartData()?.data4)"
                [legendData]="$safeNavigationMigration(receivablesChartData()?.legendData)" [colors]="$safeNavigationMigration(receivablesChartData()?.colors)"
                [tooltipData]="$safeNavigationMigration(receivablesChartData()?.tooltipData)" [unit]="datePickerValue.unit" [valueKey]="'value'"
                [showDynamicxAxisLabel]="true" [showTooltipLabel]="true" [flatBars]="true" [showLegends]="true"
                [showYAxis]="true" [legendPosition]="'center'" [legendGap]="100" [scaleType]="'log'" class="w-full">
              </app-multiple-bar>
            </div>
          </div>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.RECEIVABLES_RECOVERY)) {
      <div [ngClass]="[getSectionColClass(SectionId.RECEIVABLES_RECOVERY), chartSectionShellClass()]"
        [style.order]="sectionOrder(SectionId.RECEIVABLES_RECOVERY)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.RECEIVABLES_RECOVERY }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Receivables Recovery</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">Tracking request, funding, and completion efficiency
        </p>

        <div class="w-full min-h-[100px] flex items-center justify-center">
          @if (receivablesRecoveryProgressData.length === 0) {
          <div class="w-full flex flex-col items-center text-gray-400">
            <app-icon-v2 name="chartPie" [size]="40" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No recovery data available</p>
          </div>
          } @else {
          <app-data-progress-bar class="w-full" [data]="receivablesRecoveryProgressData" [heightClass]="'!h-3'"
            [showBorders]="true">
          </app-data-progress-bar>
          }
        </div>
      </div>
      }

      @if (showSection(SectionId.DECLINE_REASONS)) {
      <div [ngClass]="[getSectionColClass(SectionId.DECLINE_REASONS), chartSectionShellClass('flex flex-col')]"
        [style.order]="sectionOrder(SectionId.DECLINE_REASONS)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.DECLINE_REASONS }"></ng-container>
        @if(isLoading()) {
        <app-individual-toaster></app-individual-toaster>
        }
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Top Decline Reasons By Supporters</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">Reasons causing drop-off in the process</p>

        <div class="flex-1 space-y-5" [class.flex.items-center.justify-center]="declineReasons.length === 0">
          @if (declineReasons.length === 0) {
          <div class="w-full flex flex-col items-center justify-center py-10 text-gray-400">
            <app-icon-v2 name="inbox" [size]="40" class="mb-2 opacity-20"></app-icon-v2>
            <p class="text-sm italic">No decline data available</p>
          </div>
          } @else {
          @for (reason of declineReasons; track reason.label) {
          <div class="flex items-center justify-between group">
            <div class="flex items-center gap-3">
              <app-circular-progress [size]="20" [strokeWidth]="2.5" [progress]="getDeclineReasonProgress(reason.value)"
                [color]="reason.color" [backgroundColor]="reason.color + '20'"></app-circular-progress>
              <span class="text-sm text-gray-700 dark:text-gray-300 font-medium">{{ reason.label }}</span>
            </div>
            <span class="text-sm font-bold text-gray-900 dark:text-white">{{ reason.value }}</span>
          </div>
          }
          }
        </div>

        @if (declineReasons.length > 7) {
        <button
          class="mt-6 text-sm text-blue-600 dark:text-blue-400 font-medium hover:underline self-start cursor-pointer"
          (click)="toggleInsights('decline_reasons')">
          View All Decline Reasons...
        </button>
        }
      </div>
      }

    </div>
  </div>

  <app-dashboard-layout-editor [open]="isLayoutEditorOpen()" [items]="editorItems()"
    [visibleCount]="editorVisibleCount()" (closed)="closeLayoutEditor()" (applied)="applyLayoutEditor()"
    (resetDefaults)="resetLayoutEditorToDefaults()" (cardDropped)="onEditorCardDrop($any($event))"
    (visibilityToggled)="toggleEditorCardVisibility($any($event))"
    (colSpanDecreased)="decreaseEditorCardColSpan($any($event))"
    (colSpanIncreased)="increaseEditorCardColSpan($any($event))" (autoAdjustWidth)="autoAdjustEditorWidths()" />

  <!-- Key Insights Modal -->
  @if(showInsightsModal()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <!-- Backdrop with Glassmorphism -->
    <div class="absolute inset-0 bg-white/10 dark:bg-black/20 backdrop-blur-xs cursor-pointer"
      (click)="closeInsightsModal()"></div>

    <!-- Modal Content -->
    <div
      class="relative z-10 bg-white dark:bg-surface-2 backdrop-blur-xs rounded-2xl shadow-[0_0_100px_rgba(0,0,0,0.5)] w-full max-w-2xl flex flex-col overflow-hidden border border-gray-200 dark:border-gray-700">

      <!-- Header -->
      <div class="flex items-center justify-between p-4 border-b border-gray-100 dark:border-gray-700/50">
        <h3 class="text-xl font-bold text-gray-900 dark:text-white">
          {{ modalType() === 'insights' ? 'Key Insights' : 'All Decline Reasons' }}
        </h3>
        <button
          class="flex items-center p-2 rounded-full hover:bg-gray-100 dark:hover:bg-line transition-colors cursor-pointer"
          (click)="closeInsightsModal()">
          <app-icon-v2 name="x" [size]="20" class="text-gray-500 dark:text-gray-400"></app-icon-v2>
        </button>
      </div>

      <!-- Body (Scrollable) -->
      <div class="flex-1 overflow-y-auto p-4 max-h-[70vh]">
        @if (modalType() === 'insights') {
        <div class="space-y-4">
          @for(insight of keyInsights; track $index) {
          <div class="flex items-start gap-3">
            <div class="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0"></div>
            <p class="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">{{ insight }}</p>
          </div>
          }
        </div>
        } @else if (modalType() === 'decline_reasons') {
        <div class="space-y-5">
          @for (reason of declineReasons; track reason.label) {
          <div class="flex items-center justify-between group">
            <div class="flex items-center gap-3">
              <app-circular-progress [size]="24" [strokeWidth]="3" [progress]="getDeclineReasonProgress(reason.value)"
                [color]="reason.color" [backgroundColor]="reason.color + '20'"></app-circular-progress>
              <span class="text-sm text-gray-700 dark:text-gray-300 font-medium">{{ reason.label }}</span>
            </div>
            <span class="text-sm font-bold text-gray-900 dark:text-white">{{ reason.value }}</span>
          </div>
          }
        </div>
        }
      </div>

    </div>
  </div>
  }
</div>